import { SvgProps } from "../../../types";

const WorkOrdersSvg = (props: SvgProps) => (
  <svg
    width={props.width ?? 20}
    height={props.height ?? 19}
    viewBox="0 0 20 19"
    fill="none"
    {...props}
  >
    <path
      d="M2 19C1.45 19 0.979167 18.8042 0.5875 18.4125C0.195833 18.0208 0 17.55 0 17V6C0 5.45 0.195833 4.97917 0.5875 4.5875C0.979167 4.19583 1.45 4 2 4H6V2C6 1.45 6.19583 0.979167 6.5875 0.5875C6.97917 0.195833 7.45 0 8 0H12C12.55 0 13.0208 0.195833 13.4125 0.5875C13.8042 0.979167 14 1.45 14 2V4H18C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6V17C20 17.55 19.8042 18.0208 19.4125 18.4125C19.0208 18.8042 18.55 19 18 19H2ZM2 17H18V6H2V17ZM8 4H12V2H8V4Z"
      fill={props.fill ?? "#1F1F1F"}
    />
  </svg>
);

export default WorkOrdersSvg;
